import React, { FC, useState, useRef } from 'react';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import config from '../../config';
import megaNav from '../../constants/mega-nav';
import UnSubscribedMobileMenu from './UnSubscribedMobileMenu';
import UnSubscribedMobileMenuUser from './UnSubscribedMobileMenuUser';
import UnSubscribedMobileButton, {
  UnSubscribedMobileButtonContainer,
} from './UnSubscribedMobileButton';
import { NavigationItem } from '../Header/NavTypes';

const UnSubscribedHomeMenuContainer = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 2;

  margin-top: -4px;

  ${up('laptop')} {
    display: none;
  }
`;

const UnSubscribedHomeMenu: FC = () => {
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState<boolean>(false);
  const { navSkinny: globalNavData } = config;
  const handleClick = (): void => {
    setIsMobileMenuVisible(!isMobileMenuVisible);
  };
  const openMenuButton = useRef<HTMLButtonElement | null>(null);

  const closeMenu = (): void => {
    setIsMobileMenuVisible(false);
    setTimeout(() => {
      if (openMenuButton?.current !== null) {
        openMenuButton.current.focus();
      }
    }, 250);
  };

  return (
    <UnSubscribedHomeMenuContainer>
      <UnSubscribedMobileButtonContainer>
        <UnSubscribedMobileButton
          data-id="un-subscribed-home-mobile-button"
          onClick={handleClick}
          ref={openMenuButton}
        />
      </UnSubscribedMobileButtonContainer>
      <UnSubscribedMobileMenu
        breakpoint="laptop"
        currentNav="play"
        fenderConnect={<UnSubscribedMobileMenuUser />}
        globalNavData={globalNavData}
        isVisible={isMobileMenuVisible}
        onCloseMenu={closeMenu}
        navItems={megaNav as NavigationItem[]}
        titles={{
          site: 'Play',
          connect: 'Fender Connect',
          apps: 'Fender Apps',
        }}

      />
    </UnSubscribedHomeMenuContainer>
  );
};

export { UnSubscribedHomeMenu };
export default UnSubscribedHomeMenu;
